import { jsxs, jsx } from 'react/jsx-runtime';
import logger from '@agoras/logger';
import { mergeStyleSets, NeutralColors, Stack, MessageBar, MessageBarType, Link, PrimaryButton, Spinner, DefaultButton, Panel, PanelType } from '@fluentui/react';
import { useLocale } from '../../../../../hooks/useLocale.esm.js';
import { useTranslation } from 'react-i18next';
import { useState, useEffect, useCallback, useMemo } from 'react';
import { headerContext } from '../../../context.esm.js';
import { LEARN_MORE_LINK_URL } from './constants.esm.js';
import LocaleDropdown from './LocaleDropdown/LocaleDropdown.esm.js';
import MarketDropdown from './MarketDropdown/MarketDropdown.esm.js';
import { useMarket } from '../../../../../hooks/useMarket.esm.js';

function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var classNames = mergeStyleSets({
    container: {
        padding: '24px 0'
    },
    link: {
        textDecoration: 'underline'
    },
    localeBillingNotice: {
        backgroundColor: NeutralColors.white,
        border: '1px solid #EAEAEA',
        borderRadius: '2px'
    }
});
var LanguageAndRegionPanel = function(param) {
    var isOpen = param.isOpen, dismissPanel = param.dismissPanel;
    var _useState = _sliced_to_array(useState(false), 2), loadingMode = _useState[0], setLoadingMode = _useState[1];
    var _useLocale = useLocale(), locale = _useLocale.locale, onLocaleChange = _useLocale.onLocaleChange;
    var _useMarket = useMarket(), market = _useMarket.market, disabled = _useMarket.disabled, onMarketChange = _useMarket.onMarketChange;
    var _useState1 = _sliced_to_array(useState(market), 2), selectedMarket = _useState1[0], setSelectedMarket = _useState1[1];
    var _useState2 = _sliced_to_array(useState(locale), 2), selectedLocale = _useState2[0], setSelectedLocale = _useState2[1];
    useEffect(function() {
        if (!isOpen) {
            setSelectedMarket(market);
        }
    }, [
        market,
        isOpen
    ]);
    useEffect(function() {
        if (!isOpen) {
            setSelectedLocale(locale);
        }
    }, [
        locale,
        isOpen
    ]);
    var handleDismiss = useCallback(function(reason) {
        logger.info(JSON.stringify({
            reason: reason
        }), _object_spread({
            action: 'RegionLang',
            actionModifier: 'Close panel'
        }, headerContext));
        dismissPanel();
        setLoadingMode(false);
    }, [
        setLoadingMode,
        dismissPanel
    ]);
    var handleApply = useCallback(/*#__PURE__*/ _async_to_generator(function() {
        var prevMarketCode, selectedMarketCode, prevLocale, selectedLocaleCode, details;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    prevMarketCode = market.countryCode;
                    selectedMarketCode = selectedMarket.countryCode;
                    prevLocale = locale.locale;
                    selectedLocaleCode = selectedLocale.locale;
                    setLoadingMode(true);
                    if (!(prevMarketCode !== selectedMarketCode)) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        onMarketChange === null || onMarketChange === void 0 ? void 0 : onMarketChange(selectedMarketCode)
                    ];
                case 1:
                    _state.sent();
                    _state.label = 2;
                case 2:
                    if (prevLocale !== selectedLocaleCode) {
                        onLocaleChange === null || onLocaleChange === void 0 ? void 0 : onLocaleChange(selectedLocaleCode);
                    }
                    details = JSON.stringify({
                        prevMarketCode: prevMarketCode,
                        selectedMarketCode: selectedMarketCode,
                        prevLocale: prevLocale,
                        selectedLocaleCode: selectedLocaleCode
                    });
                    logger.info(details, _object_spread({
                        action: 'RegionLang',
                        actionModifier: 'Click apply'
                    }, headerContext));
                    handleDismiss('Apply');
                    return [
                        2
                    ];
            }
        });
    }), [
        handleDismiss,
        locale,
        market,
        onLocaleChange,
        onMarketChange,
        selectedLocale,
        selectedMarket
    ]);
    var t = useTranslation('header').t;
    var onRenderFooterContent = useCallback(function() {
        return /*#__PURE__*/ jsxs(Stack, {
            tokens: {
                childrenGap: 24
            },
            children: [
                /*#__PURE__*/ jsxs(MessageBar, {
                    messageBarType: MessageBarType.info,
                    className: classNames.localeBillingNotice,
                    children: [
                        t('If you select a billing country that’s different from your billing country, some apps may not be available for purchase.'),
                        /*#__PURE__*/ jsx(Link, {
                            href: LEARN_MORE_LINK_URL,
                            className: classNames.link,
                            target: "_blank",
                            rel: "noreferrer",
                            "data-bi-id": "learnMoreClicked",
                            "data-bi-area": "Language and Region",
                            children: t('Learn more')
                        })
                    ]
                }),
                /*#__PURE__*/ jsxs(Stack, {
                    horizontal: true,
                    tokens: {
                        childrenGap: 8
                    },
                    children: [
                        /*#__PURE__*/ jsx(PrimaryButton, {
                            disabled: loadingMode,
                            onClick: handleApply,
                            "data-bi-id": "CTA_SubmitFeedback",
                            "data-bi-area": "Language and Region",
                            children: loadingMode ? /*#__PURE__*/ jsx(Spinner, {}) : t('Apply')
                        }),
                        /*#__PURE__*/ jsx(DefaultButton, {
                            disabled: loadingMode,
                            onClick: function() {
                                return handleDismiss('Discard');
                            },
                            children: t('Discard')
                        })
                    ]
                })
            ]
        });
    }, [
        handleDismiss,
        handleApply,
        loadingMode,
        t
    ]);
    var panelStyles = useMemo(function() {
        return loadingMode ? {
            subComponentStyles: {
                closeButton: {
                    root: {
                        cursor: 'not-allowed',
                        pointerEvents: 'none',
                        color: NeutralColors.gray60
                    }
                }
            }
        } : {};
    }, [
        loadingMode
    ]);
    return /*#__PURE__*/ jsx(Panel, {
        type: PanelType.custom,
        customWidth: "360px",
        headerText: t('Billing country and language') || '',
        isOpen: isOpen,
        onDismiss: function() {
            return handleDismiss('Dismiss');
        },
        closeButtonAriaLabel: "Close",
        isLightDismiss: !loadingMode,
        isFooterAtBottom: true,
        onRenderFooterContent: onRenderFooterContent,
        isHiddenOnDismiss: false,
        styles: panelStyles,
        children: /*#__PURE__*/ jsxs(Stack, {
            className: classNames.container,
            tokens: {
                childrenGap: 16
            },
            children: [
                /*#__PURE__*/ jsx(MarketDropdown, {
                    market: selectedMarket,
                    onMarketChange: setSelectedMarket,
                    disabled: loadingMode || disabled
                }),
                disabled && /*#__PURE__*/ jsx(MessageBar, {
                    messageBarType: MessageBarType.info,
                    children: t('Billing country and region cannot be changed during checkout.')
                }),
                /*#__PURE__*/ jsx(LocaleDropdown, {
                    locale: selectedLocale,
                    onLocaleChange: setSelectedLocale,
                    disabled: loadingMode
                })
            ]
        })
    });
};

export { LanguageAndRegionPanel as default };
